<template>
    <v-container
        :fluid="!loading"
        :grid-list-lg="!loading"
        :fill-height="loading"
        :class="loading ? 'container-loading' : ''"
    >
        <v-layout
            wrap
            v-if="!loading"
        >
            <v-flex xs12>
                <v-slide-y-transition mode="out-in">
                    <v-layout wrap>
                        <v-flex
                            xs12
                            sm3
                            class="hidden-sm-and-down"
                        >
                            <v-slide-y-transition mode="out-in">
                                <v-card>
                                    <v-card-text>
                                        <div class="text-center mb-3">
                                            <div class="v-icon-avatar">
                                                <v-icon
                                                    dark
                                                >
                                                    $mdiAccountCircle
                                                </v-icon>
                                            </div>
                                        </div>
                                        <v-list
                                            two-line
                                            subheader
                                        >
                                            <v-list-item v-if="lead.leadReference">
                                                <v-list-item-content>
                                                    <v-list-item-title
                                                        :class="isDark ? 'white--text' : 'primary--text'"
                                                    >
                                                        Reference
                                                    </v-list-item-title>
                                                    <v-list-item-subtitle
                                                        :class="isDark ? 'white--text' : 'primary--text'"
                                                    >
                                                        {{ lead.leadReference }}
                                                    </v-list-item-subtitle>
                                                </v-list-item-content>
                                            </v-list-item>

                                            <v-list-item v-if="lead.leadFirstName">
                                                <v-list-item-content>
                                                    <v-list-item-title
                                                        :class="isDark ? 'white--text' : 'primary--text'"
                                                    >
                                                        First name
                                                    </v-list-item-title>
                                                    <v-list-item-subtitle
                                                        :class="isDark ? 'white--text' : 'primary--text'"
                                                    >
                                                        {{ lead.leadFirstName }}
                                                    </v-list-item-subtitle>
                                                </v-list-item-content>
                                            </v-list-item>

                                            <v-list-item v-if="lead.leadLastName">
                                                <v-list-item-content>
                                                    <v-list-item-title
                                                        :class="isDark ? 'white--text' : 'primary--text'"
                                                    >
                                                        Last name
                                                    </v-list-item-title>
                                                    <v-list-item-subtitle
                                                        :class="isDark ? 'white--text' : 'primary--text'"
                                                    >
                                                        {{ lead.leadLastName }}
                                                    </v-list-item-subtitle>
                                                </v-list-item-content>
                                            </v-list-item>


                                            <v-list-item v-if="lead.status_name">
                                                <v-list-item-content>
                                                    <v-list-item-title
                                                        :class="isDark ? 'white--text' : 'primary--text'"
                                                    >
                                                        Status
                                                    </v-list-item-title>
                                                    <v-list-item-subtitle
                                                        :class="isDark ? 'white--text' : 'primary--text'"
                                                    >
                                                        {{ lead.status_name }}
                                                    </v-list-item-subtitle>
                                                </v-list-item-content>
                                            </v-list-item>

                                        </v-list>
                                    </v-card-text>
                                </v-card>
                            </v-slide-y-transition>
                        </v-flex>
                        <v-flex
                            xs12
                            sm12
                            md9
                        >
                            <v-slide-y-transition mode="out-in">
                                <v-card>
                                    <v-card-text>
                                        <v-tabs
                                            class="mobile-tabs"
                                            v-model="activeTab"
                                            centered
                                            icons-and-text
                                            @change="setTabParameter"
                                            mobile-break-point="320"
                                        >
                                            <v-tabs-slider color="secondary"></v-tabs-slider>

                                            <v-tab
                                                href="#info"
                                                :class="isDark ? 'white--text' : 'primary--text'"
                                            >
                                                Information
                                                <v-icon>$mdiInformationOutline</v-icon>
                                            </v-tab>

                                            <v-tab-item value="info">
                                                <item-info
                                                    v-if="activeTab === 'info'"
                                                    :item-info="lead"
                                                ></item-info>
                                            </v-tab-item>


                                            <v-tab
                                                href="#comments"
                                                :class="isDark ? 'white--text' : 'primary--text'"
                                            >
                                                Comments
                                                <v-icon>$mdiInformationOutline</v-icon>
                                            </v-tab>

                                            <v-tab-item value="comments">
                                                <item-comments
                                                    v-if="activeTab === 'comments'"
                                                    :item-info="lead"
                                                ></item-comments>
                                            </v-tab-item>


                                            <v-tab
                                                href="#logs"
                                                :class="isDark ? 'white--text' : 'primary--text'"
                                            >
                                                Logs
                                                <v-icon>$mdiFormatListBulleted</v-icon>
                                            </v-tab>

                                            <v-tab-item value="logs">
                                                <item-logs
                                                    v-if="activeTab === 'logs'"
                                                    :item-info="lead"
                                                ></item-logs>
                                            </v-tab-item>


                                            <v-tab
                                                href="#policy"
                                                :class="isDark ? 'white--text' : 'primary--text'"
                                                v-if="typeof lead.policy !== 'undefined' && lead.policy !== null"
                                            >
                                                Policy
                                                <v-icon>$mdiClipboardTextOutline</v-icon>
                                            </v-tab>

                                            <v-tab-item value="policy">
                                                <item-policy
                                                    v-if="activeTab === 'policy'"
                                                    :item-info="lead"
                                                ></item-policy>
                                            </v-tab-item>

                                            <v-tab
                                                href="#quotations"
                                                :class="isDark ? 'white--text' : 'primary--text'"
                                                v-if="typeof lead.last_quote !== 'undefined' && lead.last_quote !== null"
                                            >
                                                Quotations
                                                <v-icon>$mdiFileDocumentOutline</v-icon>
                                            </v-tab>

                                            <v-tab-item value="quotations">
                                                <item-quotations
                                                    v-if="activeTab === 'quotations'"
                                                    :item-info="lead"
                                                ></item-quotations>
                                            </v-tab-item>
                                        </v-tabs>
                                    </v-card-text>
                                </v-card>
                            </v-slide-y-transition>
                        </v-flex>
                    </v-layout>
                </v-slide-y-transition>
            </v-flex>
        </v-layout>
        <v-layout
            v-else
            justify-center
            align-center
            column
        >
            <v-progress-circular
                :size="50"
                color="secondary"
                indeterminate
            ></v-progress-circular>
        </v-layout>
    </v-container>
</template>
<script>
    import ItemInfo from './Tabs/Info';
    import ItemComments from './Tabs/Comments';
    import ItemLogs from './Tabs/Logs';
    import ItemPolicy from './Tabs/Policy';
    import ItemQuotations from './Tabs/Quotations';

    export default {
        data() {
            return {
                loading: true,
                lead: {},

                activeTab: 'info',
            }
        },
        components: {
            ItemInfo,
            ItemComments,
            ItemLogs,
            ItemPolicy,
            ItemQuotations
        },
        computed: {
            isDark() {
                return this.$vuetify.theme.dark;
            }
        },
        name: 'View-Leads',
        mounted() {
            this.getTabParameter();
            this.getLead();
        },
        methods: {
            getLead() {
                this.loading = true;

                window.axios.post('/leads/get', {id: this.$route.params.leadId})
                    .then(response => {
                        this.lead = response.data.lead;

                        this.loading = false;
                    })
                    .catch(error => {
                        this.loading = false;
                    });
            },
        }
    }
</script>
